import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import accept from '../actions/CookieActions';

const styles = theme => ({
  cookiesAccept: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: 'auto',
    backgroundColor: '#EEEEEE',
    padding: theme.spacing(2),
    borderStyle: 'solid',
    borderWidth: '1px 0px 0px 0px',
    borderColor: 'rgba(0, 0, 0, 0.54)',
    zIndex: 10000,
  },
  dontDisplay: {
    display: 'none',
  },
  centered: {
    textAlign: 'center',
  },
  text: {
    fontSize: '16px',
    [theme.breakpoints.up(800)]: {
      paddingTop: theme.spacing(),
    },
  },
  container: {
    margin: theme.spacing(),
  },
  button: {
    [theme.breakpoints.down(800)]: {
      marginTop: theme.spacing(),
    },
  },
});

class CookiesAccept extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };

    this.handleAccept = this.handleAccept.bind(this);
  }

  handleAccept() {
    const { dispatch } = this.props;
    dispatch(accept());
  }

  render() {
    const { classes, accepted } = this.props;
    return (
      <div className={!accepted ? classes.cookiesAccept : classes.dontDisplay}>
        <Grid container className={classes.container}>
          <Grid item xs={12} sm={10} className={classes.centered}>
            <Typography className={classes.text}>This website uses cookies for analytics, personalization, and other purposes. By continuing to browse, you agree to our use of cookies.</Typography>
          </Grid>
          <Grid item xs={12} sm={2} className={classes.centered}>
            <Button variant="contained" color="secondary" onClick={this.handleAccept} className={classes.button}>Accept</Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

CookiesAccept.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const { accepted } = state.cookieReducer;
  return {
    accepted,
  };
}

export default withStyles(styles)(connect(mapStateToProps)(CookiesAccept));
